<h2 mat-dialog-title>Load {{ data.load.uniqueId }}</h2>
<mat-dialog-content class="mat-typography">
  <ng-container *ngIf="!swapMode">
    <div class="flex flex-col gap-2">
      <div>
        <span class="text-lightGray">Driver:</span> {{ data.load.driverName
        }}{{ data.load.driverPhoneNumber ? ' (' + data.load.driverPhoneNumber + ')' : '' }}
      </div>
      <div><span class="text-lightGray">Shipper:</span> {{ data.load.shipperName }}</div>
      <div><span class="text-lightGray">Origin:</span> {{ data.load.originSiteName }}</div>
      <div><span class="text-lightGray">Destination:</span> {{ data.load.destinationSiteName }}</div>
    </div>
  </ng-container>

  <ng-container *ngIf="swapMode">
    <p class="text-sm text-gray-600 mb-3">Select a driver to send this load to. This accepts the load and assigns it to them.</p>
    <div class="flex flex-col gap-1 max-h-64 overflow-y-auto">
      <button
        type="button"
        *ngFor="let driver of data.availableDrivers; trackBy: trackByDriverId"
        class="swap-driver-row w-full text-left rounded-md border px-3 py-2 transition-colors"
        [class.swap-driver-row--selected]="selectedSwapDriverId === driver.id"
        [disabled]="isLoading"
        (click)="selectedSwapDriverId = driver.id"
      >
        <div class="font-medium text-black">{{ driver.name }}</div>
        <div class="text-sm text-gray-600">{{ driver.phone }}</div>
      </button>
    </div>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <ng-container *ngIf="!swapMode">
    <button mat-button (click)="onCancel()" [disabled]="isLoading">Cancel</button>
    <button mat-button class="approval-action" (click)="onReject()" [disabled]="isLoading">Reject</button>
    <button *ngIf="showSwapDriverOption" mat-button class="approval-action" (click)="enterSwapMode()" [disabled]="isLoading">
      Swap Driver
    </button>
    <button mat-button class="approval-action" (click)="onApprove()" [disabled]="isLoading">Approve</button>
  </ng-container>
  <ng-container *ngIf="swapMode">
    <button mat-button (click)="exitSwapMode()" [disabled]="isLoading">Back</button>
    <button mat-flat-button color="primary" (click)="onAcceptAndSwapDriver()" [disabled]="isLoading || !selectedSwapDriverId">
      Accept load and swap driver
    </button>
  </ng-container>
</mat-dialog-actions>
